import { render } from "./ReportTextField.vue?vue&type=template&id=271f57fe"
import script from "./ReportTextField.vue?vue&type=script&lang=js"
export * from "./ReportTextField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__